// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_lf-0";
export var fileCarousel = "_lf-2";
export var removeFileButton = "_lf-1";